import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import { getLibraryAuthors, updateLibraryAuthorStatus, deleteLibraryAuthor } from "./libraryServices/libraryManagement";
import { useGlobalState } from "../../../services/hostelConst";
import AddLibraryAuthorForm from "./library-forms/add-author-form";

const LibraryAuthorTable = () => {
  const { toggleHostelMenu } = useGlobalState();
  var { id } = useParams();
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
    modalState,
    openModal,
  } = useGlobalState();

  useEffect(() => {
    openModal({ ...modalState, libraryId: id });
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
      };
    });

    toggleHostelMenu(false);

    return () => {};
  }, []);

  return (
    <MasterTable
      getTableData={getLibraryAuthors}
      tab1={"Library"}
      tab2={"Authors"}
      libraryId={id}
      AddForm={AddLibraryAuthorForm}
      deleteRow={deleteLibraryAuthor}
      updateStatus={updateLibraryAuthorStatus}
      actions={{
        status: true,
        edit: true,
        delete: true,
      }}
    />
  );
};

export default LibraryAuthorTable;
